import React from 'react'
import { AppCategoriesAutocomplete } from '@components'
import { object, string } from 'yup'
import { useComputed } from '@preact/signals-react'
import { useAppFormHandler } from '@hooks'
import { formData } from '@signals'


export default function CategorySelector() {

	const { idCategory, onIdCategoryChange, error } = useAppFormHandler('idCategory', object({ idCategory: string().required('Must provide a category') }))
	const categoryOptions = useComputed(() => formData.value?.categoryOptions)


	return <AppCategoriesAutocomplete
		multiple={false}
		value={idCategory}
		error={error}
		onChange={e => onIdCategoryChange(e.target.value)}
		onFinishAjax={options => formData.value = { ...formData.value, categoryOptions: options }}
		options={categoryOptions.value}
	/>
}